module.exports = __webpack_public_path__ + "img/7a.9a7728b9.png";